import { collectServerSideState } from "../../../utils/helpers/collectServerSideState";

import { BoxWrapper, Container } from "../../../components";
import { Seo } from "../../../components/Seo/Seo";
import { Faq } from "../../../components/common/Faq/Faq";
import HeadUpperSeo from "../../../components/common/HeadUpperSeo";
import { DigitalIdentity } from "./components/DigitalIdentity/DigitalIdentity";
import { AttributeTable } from "./components/attributeTable/attributeTable";

import { Section } from "../../../components/common/Section/Section.styled";

const FingerprintScanner = () => {
  return (
    <>
      <Section variant="start">
        <Container>
          <HeadUpperSeo />

          <BoxWrapper>
            <DigitalIdentity />
            <AttributeTable />
          </BoxWrapper>
        </Container>
      </Section>
      <Faq sectionType="innerTools" />
      <Seo sectionType="innerTools" />
    </>
  );
};

FingerprintScanner.getServerSideState = async (store, params) => {
  await collectServerSideState(store, params);
};

export default FingerprintScanner;
